var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: _vm.editMode ? "yellow darken-3" : "primary",
                    dark: "",
                    dense: "",
                    elevation: "0"
                  }
                },
                [_c("span", [_vm._v(_vm._s(_vm.editMode ? "Edit" : "New"))])]
              ),
              _c("create-feeding-program", {
                attrs: { "default-field-values": _vm.editFeedingProgramData },
                on: {
                  "update:defaultFieldValues": function($event) {
                    _vm.editFeedingProgramData = $event
                  },
                  "update:default-field-values": function($event) {
                    _vm.editFeedingProgramData = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    color: "primary",
                    dark: "",
                    dense: "",
                    elevation: "0"
                  }
                },
                [_c("span", [_vm._v("List")])]
              ),
              _c("table-feeding-program", {
                model: {
                  value: _vm.editFeedingProgramData,
                  callback: function($$v) {
                    _vm.editFeedingProgramData = $$v
                  },
                  expression: "editFeedingProgramData"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }